"use client";

import { twMerge } from "tailwind-merge";
import { useIsDark } from "@/context/ThemeContext";
import { Skeleton } from "antd";
import { BlogCardSkeleton } from "@/components/skeletons/BlogCardSkeleton";

export default function AuthorPageSkeleton() {
  const isdark = useIsDark();

  return (
    <div className="relative flex flex-col justify-center items-center mt-20 xl:mt-0 mx-5 md:mx-[40px] xl:mx-[100px] 3xl:mx-[150] z-10">
      {/* Hero Section Skeleton */}
      <div className="relative flex flex-col justify-center items-center text-center xl:h-[100vh] w-full z-50 mt-16 xl:mt-0 lg:mt-[80px]">
        {/* AUTHOR heading skeleton */}
        <Skeleton.Input
          active
          size="large"
          className="!h-[70px] mobile:!h-[120px] sm:!h-[150px] md:!h-[180px] lg:!h-[210px] tablet:!h-[220px] xl:!h-[230px] laptop:!h-[230px] 3xl:!h-[290px] 4xl:!h-[330px] !w-full mx-auto mb-4"
          style={{
            backgroundColor: isdark ? "#374151" : "",
          }}
        />

        {/* Subheading skeleton */}
        <Skeleton.Input
          active
          size="default"
          className="!h-8 !w-60 mb-4 mt-4 xl:mt-[10px]"
          style={{
            backgroundColor: isdark ? "#374151" : "",
          }}
        />

        {/* Paragraph skeleton */}
        <Skeleton.Input
          active
          size="small"
          className="!h-6 !w-96 max-w-full mt-4 xl:mt-[24px]"
          style={{
            backgroundColor: isdark ? "#374151" : "",
          }}
        />
      </div>

      {/* Author Info Section Skeleton */}
      <div
        className={twMerge(
          "relative flex flex-col items-center justify-center w-full max-w-4xl mx-auto p-6 md:p-8 lg:p-10 rounded-[20px] lg:rounded-[40px] mt-16 mb-10",
          isdark ? "bg-[#0F0F0F]" : "bg-[#F2E4FE]"
        )}
        style={{
          "--ant-skeleton-color": isdark ? "#374151" : "",
          "--ant-skeleton-to-color": isdark ? "#4B5563" : "",
        }}
      >
        {/* Author Avatar Skeleton */}
        <Skeleton.Avatar
          active
          size={160}
          className="mb-6"
          style={{
            backgroundColor: isdark ? "#374151" : "",
          }}
        />

        {/* Author Name Skeleton */}
        <Skeleton.Input
          active
          size="large"
          className="mb-4 !w-64 !h-12"
          style={{
            backgroundColor: isdark ? "#374151" : "",
          }}
        />

        {/* Author Bio Skeleton */}
        <div className="flex flex-col items-center gap-2 mb-4 w-full max-w-lg">
          <Skeleton
            active
            paragraph={{ rows: 3, width: ["100%", "90%", "80%"] }}
            title={false}
            style={{
              "--ant-skeleton-color": isdark ? "#374151" : "",
              "--ant-skeleton-to-color": isdark ? "#4B5563" : "",
            }}
          />
        </div>

        {/* Post Count Skeleton */}
        <Skeleton.Input
          active
          size="small"
          className="!w-32 !h-6"
          style={{
            backgroundColor: isdark ? "#374151" : "",
          }}
        />
      </div>

      {/* Blog Cards Grid Skeleton */}
      <div className="mt-16 w-full">
        <div className="grid grid-cols-1 mobile:grid-cols-2 md:grid-cols-3 tablet:grid-cols-3 gap-4 mobile:gap-3 sm:gap-4 md:gap-3 tablet:gap-6 lg:gap-10 2xl:gap-20 3xl:gap-30">
          {Array.from({ length: 6 }).map((_, i) => (
            <BlogCardSkeleton key={i} />
          ))}
        </div>
      </div>

      {/* Pagination Skeleton */}
      <div className="flex justify-center mt-10 mb-10 px-2">
        <Skeleton.Button
          active
          size="default"
          className="!w-64 !h-10"
          style={{
            backgroundColor: isdark ? "#374151" : "",
          }}
        />
      </div>
    </div>
  );
}
